<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>favorite</md-icon>
          </div>
          <h4 class="title">Activity Labourer Workplace List</h4>
        </md-card-header>
        <md-card-content>
          <div class="text-right">
            <md-button @click="goToAdd" class="md-primary md-dense">
              Add Activity Labourer Workplace
            </md-button>
          </div>
          <md-table
              :value="table"
              :md-sort.sync="sortation.field"
              :md-sort-order.sync="sortation.order"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label>Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                    v-model="query"
                    type="search"
                    class="mb-3"
                    clearable
                    style="width: 200px"
                    placeholder="Search ..."
                >
                </md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Labourer" md-sort-by="labourer.first_name">
                {{ item.labourer ? item.labourer.name : '' }}
              </md-table-cell>
              <md-table-cell md-label="Activity" md-sort-by="activity.name">
                {{ item.activity ? item.activity.name : '' }}
              </md-table-cell>
              <md-table-cell md-label="Workplace" md-sort-by="workplace.name">
                {{ item.workplace ? item.workplace.name : '' }}
              </md-table-cell>
              <md-table-cell md-label="Start Date" md-sort-by="start_date">{{ toLocal(item.start_date) }}
              </md-table-cell>
              <md-table-cell md-label="End Date" md-sort-by="end_date">{{ toLocal(item.end_date) }}</md-table-cell>

              <md-table-cell md-label="Actions">
                <md-button
                    class="md-icon-button md-raised md-round md-info"
                    @click="goToView(item.id)"
                    style="margin: 0.2rem"
                >
                  <md-icon>visibility</md-icon>
                </md-button>
                <md-button
                    class="md-icon-button md-raised md-round md-info"
                    @click="goToEdit(item)"
                    style="margin: 0.2rem"
                >
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button
                    class="md-icon-button md-raised md-round md-danger"
                    @click="destroy(item.id)"
                    style="margin: 0.2rem"
                >
                  <md-icon>delete</md-icon>
                </md-button>
                <md-button
                    class="md-icon-button md-raised md-round md-danger"
                    @click="delimit(item)"
                    style="margin: 0.2rem"
                >
                  <md-icon>swap_horiz</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <div class="footer-table md-table">
            <table>
              <tfoot>
              <tr>
                <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                >
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">
                      {{ item }}
                    </div>
                  </div>
                </th>
              </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
          />
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import DateFormatMixin from '@/mixins/date-format-mixin';
import _ from 'lodash';
import Pagination from '@/components/Pagination';
import Swal from 'sweetalert2';


export default {
    components: {
        pagination: Pagination,
    },
    mixins: [DateFormatMixin],
    data: () => ({
        table: [],
        footerTable: [
            'Labourer',
            'Activity',
            'Workplace',
            'Start Date',
            'End Date',
            'Actions'],

        query: null,

        sortation: {
            field: 'created_at',
            order: 'asc',
        },

        pagination: {
            perPage: 10,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
        },

        total: 0,
    }),

    computed: {
        sort () {
            if (this.sortation.order === 'desc') {
                return `-${this.sortation.field}`;
            }
            return this.sortation.field;
        },

        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },

        to () {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
    },

    watch: {
        query: {
            handler: 'getListDebounced',
            immediate: true,
        },
        sortation: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
        pagination: {
            handler: 'getList',
            immediate: false,
            deep: true,
        },
    },

    methods: {
        getListDebounced: _.debounce(function () {
            this.getList();
        }, 300),

        async getList () {
            let params = {
                include: 'activity,labourer,workplace',
                ...(this.sort ? { sort: this.sort } : {}),
                filter: {
                    ...(this.query ? { name: this.query } : {}),
                },
                page: {
                    number: this.pagination.currentPage,
                    size: this.pagination.perPage,
                },
            };

            try {
                await this.$store.dispatch('activityLabourerWorkplaces/list', params);
                this.table = this.$store.getters['activityLabourerWorkplaces/list'];
                this.total = this.$store.getters['activityLabourerWorkplaces/listTotal'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async destroy (activityLabourerWorkplace) {
            const confirmation = await Swal.fire({
                title: 'Delete this Activity Labourer Workplace?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, keep it',
                confirmButtonClass: 'md-button md-success',
                cancelButtonClass: 'md-button md-danger',
            });

            if (confirmation.value === true) {
                try {
                    await this.$store.dispatch('activityLabourerWorkplaces/destroy', activityLabourerWorkplace);
                    await this.$store.dispatch(
                        'alerts/success',
                        'Activity Labourer Workplace deleted successfully.'
                    );
                    await this.getList();
                } catch (e) {
                    if (e.response.data.errors[0]) {
                        await this.$store.dispatch(
                            'alerts/error',
                            e.response.data.errors[0].title
                        );
                    } else {
                        await this.$store.dispatch(
                            'alerts/error',
                            'Oops, something went wrong!'
                        );
                    }
                }
            }
        },

        async delimit (activityLabourerWorkplace) {
            if (activityLabourerWorkplace.end_date) {
                this.notifyError('Assignment already delimited');
                return;
            }
            const end_date = this.nowLocal('YYYY-MM-DD');
            const confirmation = await Swal.fire({
                title: 'End Labourer Activity Workplace Assignment?',
                text: `end  date for this assignment will be ${end_date} labourer will not have privileges for assigment on this workplace`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, Delimit!',
                cancelButtonText: 'Cancel',
                confirmButtonClass: 'md-button md-success',
                cancelButtonClass: 'md-button md-danger',
            });

            if (confirmation.value === true) {
                try {
                    activityLabourerWorkplace.end_date = this.nowLocal('YYYY-MM-DD');
                    activityLabourerWorkplace.start_date = this.toLocal(activityLabourerWorkplace.start_date);
                    await this.$store.dispatch('activityLabourerWorkplaces/update', activityLabourerWorkplace);
                    await this.$store.dispatch(
                        'alerts/success',
                        'Activity Labourer Workplace delimit successfully.'
                    );
                    await this.getList();
                } catch (e) {
                    this.notifyException(e);
                }
            }
        },

        goToAdd () {
            this.$router.push({ name: 'Add Activity Labourer Workplace' });
        },

        goToEdit (activityLabourerWorkplace) {
            if (activityLabourerWorkplace.end_date) {
                Swal.fire({
                    icon: 'error',
                    title: 'Edit Assignment not Possible',
                    text: 'this assignment have already delimited. no further edit possible. please create new',
                    timer: 5000,
                });
                return;
            }
            const id = activityLabourerWorkplace.id;
            this.$router.push({ name: 'Edit Activity Labourer Workplace', params: { id } });
        },

        goToView (id) {
            this.$router.push({ name: 'View Activity Labourer Workplace', params: { id } });
        },

        customSort () {
            return false;
        },
    },
};
</script>
